<template>
   <div>
     <v-menu attach offset-y bottom left origin="top right">
          <v-btn icon small   flat slot="activator" class="ma-0">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="11" cy="11" r="11" fill="blue"/>
          <path d="M10.9998 7.69922V15.3992" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14.8506 11.55L7.15063 11.55" stroke="white" stroke-width="2"  stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile class="pl-0" v-for="(item,index) in items" :to="!item.href ? { name: item.name } : null" :href="item.href" @click="item.click" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index">
            <v-list-tile-action v-if="item.icon">
              <!-- <v-icon>{{ item.icon }}</v-icon> -->
              <v-img contain width="10px" height="20px" :src="item.icon" />
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
      </div>
</template>
<script>
  export default {
    data: () => ({
      User: {
          first_name:""
      },
     items: [
      
      { 
        icon:'',      
        title: 'Subscribe to a Report',
        href: '/reportSubscriptions',
        click: (e) => {
          console.log(e);
        }
      }
    ],

    }),
 
  }
</script>